import { useCallback } from 'react'
import { getSnackbarInstance } from '@/context/SnackbarContext'

export const useHelper = () => {
  const showToaster = useCallback(
    (
      message: string,
      type: 'success' | 'error' | 'info' | 'warning' | null = null,
    ) => {
      const snackbar = getSnackbarInstance()
      if (!snackbar) {
        console.warn('Snackbar instance not available')
        return
      }

      switch (type) {
        case 'success':
          snackbar.showSuccess(message)
          break
        case 'error':
          snackbar.showError(message)
          break
        case 'info':
          snackbar.showInfo(message)
          break
        case 'warning':
          snackbar.showWarning(message)
          break
        default:
          snackbar.showError(message)
      }
    },
    [],
  )

  const formatBytes = useCallback((bytes: number): string => {
    const marker = 1024
    const decimal = 3
    const kiloBytes = marker
    const megaBytes = marker * marker
    const gigaBytes = marker * marker * marker

    if (bytes < kiloBytes) return bytes + ' Bytes'
    else if (bytes < megaBytes)
      return (bytes / kiloBytes).toFixed(decimal) + ' KB'
    else if (bytes < gigaBytes)
      return (bytes / megaBytes).toFixed(decimal) + ' MB'
    else return (bytes / gigaBytes).toFixed(decimal) + ' GB'
  }, [])

  return {
    showToaster,
    formatBytes,
  }
}
